import React, { useMemo } from 'react';
import {
  DependencyManagerProvider,
  useDependencyManagerContext
} from 'src/contexts/dependencyManager';
import Router from 'src/router';
import * as T from './types';
import '../styles/global.scss';
import {
  ContainerMFE,
  FeatureFlagKeyValues,
  useGetFeatureFlags,
  BackgroundProcess
} from '@uma/react-commons/dist';

export interface FeatureFlagProps {
  isLoading: boolean;
  securityHPIDEmail: boolean;
  securityHPIDPhone: boolean;
  securityHPIDPassword: boolean;
  securityShowActiveSessions: boolean;
  originalFeedbackExperience: boolean;
  securityHPIDMfa: boolean;
  securityHpIdMfaEnableRedirect: boolean;
  securityLoginMethodsFieldEnabled: boolean;
  securityLoginMethodsRedirectEnabled: boolean;
}

const AppComponent: React.FC<T.AppPropsType> = () => {
  const { northboundAPIs } = useDependencyManagerContext();

  const featureFlagClient = useMemo(
    () => northboundAPIs?.v1?.featureFlags?.getClient,
    [northboundAPIs?.v1?.featureFlags?.getClient]
  );

  const featureFlagProps = useGetFeatureFlags({
    getClient: featureFlagClient,
    keys: [
      FeatureFlagKeyValues.securityHPIDEmail,
      FeatureFlagKeyValues.securityHPIDPhone,
      FeatureFlagKeyValues.securityHPIDPassword,
      FeatureFlagKeyValues.securityHPIDMfa,
      FeatureFlagKeyValues.securityHpIdMfaEnableRedirect,
      FeatureFlagKeyValues.originalFeedbackExperience,
      FeatureFlagKeyValues.securityShowActiveSessions,
      FeatureFlagKeyValues.securityLoginMethodsFieldEnabled,
      FeatureFlagKeyValues.securityLoginMethodsRedirectEnabled
    ]
  });

  return (
    <ContainerMFE data-testid="security-page">
      <Router {...featureFlagProps} />
    </ContainerMFE>
  );
};

const App: React.FC<T.AppPropsType> = () => {
  return (
    <>
      <BackgroundProcess />
      <DependencyManagerProvider>
        <AppComponent />
      </DependencyManagerProvider>
    </>
  );
};

export default App;
